import type { GqlExecutor } from '@hopdrive/sdk-core';

/**
 * The executor the invoice screens' Amount Due reads go through. The app's
 * Apollo setup registers one that skips the cache: those reads are used once,
 * and writing each answer into the cache would make Apollo re-read every
 * watched query it touches. Until one is registered, as in tests, sdk-ar reads
 * through the executor `init()` registered.
 */
let amountDueExecutor: GqlExecutor | undefined;

export function setAmountDueExecutor(executor: GqlExecutor): void {
  amountDueExecutor = executor;
}

export function getAmountDueExecutor(): GqlExecutor | undefined {
  return amountDueExecutor;
}
